export default __webpack_public_path__ + "static/media/action-tick-checked.eafaff95.svg";